import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { setAddSpecMealDialog, addCartItemSeparately } from '../../actions/dineIn';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import SpecSelectionListWrapperNew from './SpecSelectionListWrapperNew';
import { getSpecMealPrice, getAllSpecPrice } from '../../utils/meal';
import { SelectionRule } from '../../utils/SelectionRule';
import lng from '../../misc/lng';
import envConst from '../../misc/envConst';
import { useFontSize } from '../../contexts/FontSizeContext';

const { chiLng } = lng;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
    },
    imageHeader: {
        height: '40vh',
        minHeight: '250px',
        maxHeight: '400px',
        position: 'relative',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f5f5f5',
    },
    backButton: {
        position: 'fixed',
        top: theme.spacing(2),
        left: theme.spacing(2),
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        zIndex: 1000,
        width: 44,
        height: 44,
        borderRadius: '50%',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        // Add safe area for mobile devices
        '@media (max-width: 768px)': {
            top: 'max(env(safe-area-inset-top), 16px)',
            left: 'max(env(safe-area-inset-left), 16px)',
            width: 40,
            height: 40,
        },
    },
    scrollableWrapper: {
        flex: 1,
        overflow: 'auto',
        paddingBottom: theme.spacing(10), // Space for bottom section
        // Handle mobile viewport issues
        minHeight: 0, // Allow flex child to shrink
        WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '60vh', // Use viewport height instead of calc
        flex: 1,
    },
    card: {
        backgroundColor: '#FFFFFF',
        elevation: 2,
        marginTop: -80,
        borderRadius: 12,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 5,
    },
    scrollableContent: {
        flex: 1,
    },
    cardContent: {
        padding: theme.spacing(2),
    },
    productTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#212121',
        marginBottom: theme.spacing(1),
    },
    productSubtitle: {
        fontSize: '14px',
        color: '#757575',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    priceContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    currentPrice: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212121',
    },
    originalPrice: {
        fontSize: '14px',
        color: '#BDBDBD',
        textDecoration: 'line-through',
        marginLeft: theme.spacing(1),
    },
    section: {
        marginBottom: theme.spacing(3),
    },
    sectionTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#212121',
        marginBottom: theme.spacing(1),
    },
    optionsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    optionChip: {
        backgroundColor: '#f5f5f5 !important',
        color: '#212121 !important',
        border: '1px solid #E0E0E0',
        minWidth: 'auto',
        height: '32px',
        '&:hover': {
            backgroundColor: '#e0e0e0 !important',
        },
        '& .MuiChip-label': {
            color: '#212121 !important',
            fontSize: 'inherit !important',
        },
    },
    optionChipSelected: {
        backgroundColor: '#4CAF50 !important',
        color: '#FFFFFF !important',
        border: '1px solid #4CAF50',
        minWidth: 'auto',
        height: '32px',
        '&:hover': {
            backgroundColor: '#45a049 !important',
            border: '1px solid #45a049',
        },
        '& .MuiChip-label': {
            color: '#FFFFFF !important',
            fontSize: 'inherit !important',
        },
    },
    bottomSection: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#FFFFFF',
        padding: theme.spacing(2),
        borderTop: '1px solid #E0E0E0',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        zIndex: 10,
        // Handle mobile safe areas
        paddingBottom: 'max(env(safe-area-inset-bottom), 16px)',
        paddingLeft: 'max(env(safe-area-inset-left), 16px)',
        paddingRight: 'max(env(safe-area-inset-right), 16px)',
    },
    quantitySection: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    quantityButton: {
        backgroundColor: '#f5f5f5',
        border: '1px solid #E0E0E0',
        borderRadius: '50%',
        width: 40,
        height: 40,
        '&:hover': {
            backgroundColor: '#e0e0e0',
        },
        '&:disabled': {
            backgroundColor: '#f5f5f5',
            color: '#bdbdbd',
        },
    },
    quantityText: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212121',
        minWidth: 30,
        textAlign: 'center',
    },
    actionButton: {
        flex: 1,
        backgroundColor: '#4CAF50',
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: 12,
        padding: theme.spacing(1.5),
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#45a049',
        },
    },
    actionButtonDisabled: {
        flex: 1,
        backgroundColor: '#BDBDBD',
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'bold',
        borderRadius: 12,
        padding: theme.spacing(1.5),
        textTransform: 'none',
    },

}));

export default () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { getFontSize } = useFontSize();

    // Dynamic font sizes
    const titleFontSize = getFontSize('mealTitle');
    const subtitleFontSize = getFontSize('subtitle');
    const priceFontSize = getFontSize('priceMain');
    const buttonFontSize = getFontSize('buttonText');
    const quantityFontSize = getFontSize('priceMain');
    const {
        addSpecMealDialog: {
            open, data
        }
    } = useSelector((store) => store.dineInReducer);

    const {
        menu: { simpleOptionList }
    } = useSelector((store) => store.menuReducer);

    const [qty, setQty] = useState(1);
    const [simpleOptList, setSimpleOptList] = useState([]);
    const [specList, setSpecList] = useState([]);
    const [selectedSpecList, setSelectedSpecList] = useState([]);
    const [img, setImg] = useState(envConst.DEFAULT_IMG_PATH);

    // Process specifications to add SelectionRule instances
    const processSpecifications = (apiSpecifications) => {
        return apiSpecifications.map(spec => {
            // Create SelectionRule instance
            let selectionRule;
            if (spec.selectionRule) {
                // New format
                selectionRule = new SelectionRule(spec.selectionRule);
            } else {
                // Legacy format - fallback to minQty/maxQty
                selectionRule = SelectionRule.fromLegacy(
                    spec.minQty || 0,
                    spec.maxQty || 1
                );
            }

            return {
                ...spec,
                selectionRule, // Add SelectionRule instance
                specOptions: spec.specOptions.map(opt => ({
                    ...opt,
                    selected: false // Initialize selection state
                }))
            };
        });
    };

    const handleClickSimpleOpt = (opt) => {
        setSimpleOptList(
            simpleOptList.map(
                (sOpt) => {
                    if (opt.id === sOpt.id) {
                        return {
                            ...sOpt,
                            selected: !sOpt.selected,
                        };
                    }
                    return sOpt;
                }
            )
        );
    };

    const getSelected = (list) => {
        return list.filter(l => l.selected).length;
    };

    const isSpecFulfilled = (spec) => {
        const numOfSelected = getSelected(spec.specOptions);

        // Use SelectionRule if available, otherwise fallback to legacy logic
        if (spec.selectionRule) {
            return spec.selectionRule.isValidQuantity(numOfSelected);
        }

        // Legacy fallback logic
        const { maxQty, minQty } = spec;
        if (maxQty === minQty) {
            return numOfSelected === maxQty;
        } else if (numOfSelected <= maxQty && numOfSelected >= minQty) {
            return true;
        }
        return false;
    };

    const isConfirmDisabled = () => {
        let isFulfill = true;
        specList.forEach(
            (spec) => {
                if (!isSpecFulfilled(spec)) {
                    isFulfill = false;
                }
            }
        );
        return !isFulfill;
    };

    const handleQtyAdd = () => {
        if (qty < 99) {
            setQty(qty + 1);
        }
    };

    const handleQtyReduce = () => {
        if (qty > 1) {
            setQty(qty - 1);
        }
    };

    const handleClose = () => {
        dispatch(setAddSpecMealDialog(false, {}));
    };

    const handleConfirm = () => {
        console.log('handleConfirm');
        const mealToAdd = {
            ...data,
            productSpec: [{
                priceForOne: getAllSpecPrice(selectedSpecList) + data.price,
                qty,
                spec: selectedSpecList
            }],
            simpleOptions: simpleOptList.filter(
                so => so.selected
            ).map(
                so => so.optionName
            ),
        };
        console.log(mealToAdd);
        dispatch(addCartItemSeparately(mealToAdd));
        handleClose();
    };

    const getTotalPrice = () => {
        return getSpecMealPrice(
            {
                ...data,
                specList: selectedSpecList,
            }
        ) * qty;
    };

    const handleSpecChange = (optIdx, specIdx) => {
        const newSpecList = specList.map(
            (spec, sIdx) => {
                if (specIdx === sIdx) {
                    const currentSelected = spec.specOptions.filter(opt => opt.selected).length;

                    return {
                        ...spec,
                        specOptions: spec.specOptions.map(
                            (opt, oIdx) => {
                                if (oIdx !== optIdx) return opt;

                                // Handle selection based on SelectionRule if available
                                if (spec.selectionRule) {
                                    // Special handling for exact rule with value 1 (radio button behavior)
                                    if (spec.selectionRule.ruleType === 'exact' && spec.selectionRule.exact === 1) {
                                        if (oIdx === optIdx) {
                                            return { ...opt, selected: true };
                                        }
                                        return { ...opt, selected: false };
                                    }

                                    if (!opt.selected) {
                                        const newCount = currentSelected + 1;

                                        // Check if selection should be blocked (only for rules with upper limits)
                                        if (spec.selectionRule.ruleType === 'max' && newCount > spec.selectionRule.max) {
                                            return opt; // Block selection
                                        }
                                        if (spec.selectionRule.ruleType === 'exact' && newCount > spec.selectionRule.exact) {
                                            return opt; // Block selection
                                        }
                                        if (spec.selectionRule.ruleType === 'between' && newCount > spec.selectionRule.max) {
                                            return opt; // Block selection
                                        }
                                        // For 'min' and 'any' rules, always allow selection
                                    }

                                    return { ...opt, selected: !opt.selected };
                                }

                                // Legacy logic fallback
                                if (oIdx === optIdx) {
                                    return {
                                        ...opt,
                                        selected: !opt.selected,
                                    };
                                }
                                return opt;
                            }
                        )
                    };
                }
                return spec;
            }
        );
        setSpecList(newSpecList);
    };

    const onEnter = () => {
        if (!open) {
            return;
        }

        if (data && data.img) {
            setImg(`${envConst.IMAGE_PATH}${data.img}`);
        } else {
            setImg(envConst.DEFAULT_IMG_PATH);
        }

        setQty(1);
        setSimpleOptList(
            simpleOptionList.map(
                (opt) => ({
                    ...opt,
                    selected: false,
                })
            )
        );

        if (data.specList) {
            const processedSpecs = processSpecifications(data.specList);
            setSpecList(processedSpecs);
        }
    };

    const handleImgError = () => {
        setImg(envConst.DEFAULT_IMG_PATH);
    };

    useEffect(
        () => {
            setSelectedSpecList(
                specList.map(
                    (spec) => ({
                        ...spec,
                        specOptions: spec.specOptions.filter(opt => opt.selected),
                    })
                ).filter(spec => spec.specOptions.length > 0)
            );
        }, [specList]
    );

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            fullScreen
            TransitionProps={{ onEnter: onEnter }}
        >
            <div className={classes.root}>
                {/* Scrollable Wrapper for Image Header and Content */}
                <div className={classes.scrollableWrapper}>
                    {/* Image Header */}
                    <div
                        className={classes.imageHeader}
                        style={{
                            backgroundImage: `url(${img})`,
                        }}
                    >
                        <IconButton
                            className={classes.backButton}
                            onClick={handleClose}
                            aria-label="back"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    </div>

                    {/* Content Container */}
                    <div className={classes.contentContainer}>
                        <Card className={classes.card}>
                            <div className={classes.scrollableContent}>
                                <CardContent className={classes.cardContent}>
                                    {/* Product Title and Subtitle */}
                                    <Typography
                                        variant="inherit"
                                        className={classes.productTitle}
                                        style={{ fontSize: titleFontSize }}
                                    >
                                        {data?.name || ''}
                                    </Typography>

                                    {data?.description && (
                                        <Typography
                                            variant="inherit"
                                            className={classes.productSubtitle}
                                            style={{ fontSize: subtitleFontSize }}
                                        >
                                            {data.description}
                                        </Typography>
                                    )}

                                    {/* Price */}
                                    <div className={classes.priceContainer}>
                                        <Typography
                                            variant="inherit"
                                            className={classes.currentPrice}
                                            style={{ fontSize: priceFontSize }}
                                        >
                                            ${data?.price || '0.00'}
                                        </Typography>
                                    </div>

                                    {/* Spec Selection Section */}
                                    {specList && specList.length > 0 && (
                                        <div className={classes.section}>
                                            <SpecSelectionListWrapperNew
                                                specList={specList}
                                                handleChange={handleSpecChange}
                                            />
                                        </div>
                                    )}

                                    {/* Simple Options Section */}
                                    {simpleOptList.length > 0 && (
                                        <div className={classes.section}>
                                            <Typography
                                                variant="inherit"
                                                className={classes.sectionTitle}
                                                style={{ fontSize: getFontSize('bodyText') }}
                                            >
                                                {chiLng.simpleOptTitle}
                                            </Typography>
                                            <div className={classes.optionsContainer}>
                                                {simpleOptList.map((opt, idx) => (
                                                    <Chip
                                                        key={idx}
                                                        label={opt.optionName}
                                                        onClick={() => handleClickSimpleOpt(opt)}
                                                        className={opt.selected ? classes.optionChipSelected : classes.optionChip}
                                                        clickable
                                                        variant="outlined"
                                                        size="medium"
                                                        style={{ fontSize: getFontSize('buttonText') }}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </CardContent>
                            </div>
                        </Card>
                    </div>
                </div>

                {/* Sticky Bottom Section with Quantity and Action Button */}
                <div className={classes.bottomSection}>
                    {/* Quantity Selector */}
                    <div className={classes.quantitySection}>
                        <IconButton
                            className={classes.quantityButton}
                            onClick={handleQtyReduce}
                            disabled={qty <= 1}
                        >
                            <RemoveIcon />
                        </IconButton>

                        <Typography
                            variant="inherit"
                            className={classes.quantityText}
                            style={{ fontSize: quantityFontSize }}
                        >
                            {qty}
                        </Typography>

                        <IconButton
                            className={classes.quantityButton}
                            onClick={handleQtyAdd}
                            disabled={qty >= 99}
                        >
                            <AddIcon />
                        </IconButton>
                    </div>

                    {/* Action Button */}
                    <Button
                        className={isConfirmDisabled() ? classes.actionButtonDisabled : classes.actionButton}
                        onClick={handleConfirm}
                        disabled={isConfirmDisabled()}
                        style={{ fontSize: buttonFontSize }}
                    >
                        {`${chiLng.addOrder} - $${getTotalPrice().toFixed(2)}`}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
